import $api from '../../../api';
import languages from '../../../utils/languages';
import getHashOrDefault from '../../../utils/getHashOrDefault';
import IntegrateSlackButton from '../../../components/integrateSlackButton';
import DisconnectSlackButton from '../../../components/disconnectSlackButton';
import { koComponent } from '../../../ko-utils';

class AlertsView {
    constructor(p, rootParams) {
        this.page = rootParams;

        IntegrateSlackButton();
        DisconnectSlackButton();

        this.activeTab = ko.observable('alerts');

        this.integrations = {
            newAlertsChannel: ko.observable(),
            newAlertsEmail: ko.observable(new EmailDigestSettings())
        };

        this.issuesPageInfo = {};
        this.issues = ko.observableArray();

        this.selectedTour = ko.observable();
        this.selectedTour.subscribe(() => {
            this.issuesGetPage(1);
        });

        this.resolveStatuses = [
            { val: false, text: 'Unresolved' },
            { val: true, text: 'Resolved' }
        ];

        this.selectedResolveStatus = ko.observable(this.resolveStatuses[0].val);
        this.selectedResolveStatus.subscribe(() => {
            this.issuesGetPage(1);
        });

        this.checkedItems = ko.observableArray();
        this.isCheckedAll = ko.pureComputed(() => {
            return this.checkedItems().length == this.issues().length;
        })

        this.onInit();
    }

    onInit() {
        this.tours = ko.observableArray(this.page.getServerSideData('tours'));

        this.integrations.newAlertsChannel(this.page.getServerSideData('slackIntegrationData').newAlertsChannel);
        this.integrations.newAlertsEmail(new EmailDigestSettings(this.page.getServerSideData('emailIntegrationData')));

        this.issuesGetPage(1);
    }

    setActiveTab(tab) {
        this.activeTab(tab);
    }

    goToTour(id) {
        window.location.href = '/' + auth.project.UniqueCode + '/tours/detail/' + id;
    }

    issuesGetPage(page) {
        this.page.startSubmitting('loading');
        $api.diag.list(
            { projectCode: auth.project.UniqueCode, id: this.selectedTour(), page: page, resolvedStatus: this.selectedResolveStatus() },
            {},
            (resp) => {
                this.page.stopSubmitting('loading');

                for (const item of resp.items) {
                    if (!item.isResolved) item.isResolved = false;
                }

                this.issues.valueWillMutate();
                this.issues(resp.items);
                this.issues.valueHasMutated();
                resp.items = null;
                this.issuesPageInfo.page = page;
            }
        );
    }

    resolve(item) {
        $api.diag.resolveItem(
            { projectCode: auth.project.UniqueCode, id: item.id },
            {},
            (resp) => {
                this.issuesGetPage(1);
            }
        );
    }

    resolveBulk() {
        this.page.startSubmitting('bulk_all');
        $api.diag.resolveBulk(
            { projectCode: auth.project.UniqueCode, ids: this.checkedItems().map(i => ko.unwrap(i.id)) },
            {},
            (resp) => {
                this.page.stopSubmitting('bulk_all');
                this.checkedItems.removeAll();
                this.issuesGetPage(1);
            }
        );
    }

    humanizeReason(reason) {
        if (reason == 'missing_element') {
            return 'Missing element';
        } else {
            return reason;
        }
    }

    saveIntegrations() {
        this.page.startSubmitting('saveIntegrations');

        $api.integrations.saveAlertsSettings(
            { projectCode: auth.project.UniqueCode },
            {
                channel: this.integrations.newAlertsChannel(),
                email: this.integrations.newAlertsEmail().isEnabled() ? ko.toJS(this.integrations.newAlertsEmail().email()) : null,
            },
            (resp) => {
                this.page.stopSubmitting('saveIntegrations');
                this.showToast('Integration settings saved.');
            }
        );
    }

    toggleCheckAll() {
        return ko.computed({
            read: () => {
                return this.checkedItems().length > 0;
            },
            write: (val) => {
                this.checkedItems.valueWillMutate();

                if (this.checkedItems().length != this.issues().length) {
                    this.checkedItems.removeAll();

                    for (var item of this.issues()) {
                        this.checkedItems.push(item);
                    }
                } else {
                    this.checkedItems.removeAll();
                }

                this.checkedItems.valueHasMutated();
            }
        });
    }

    isChecked(item) {
        return ko.computed({
            read: () => {
                return this.checkedItems().some(i => i == item);
            },
            write: (val) => {
                if (val && !this.checkedItems().some(i => i == item)) {
                    this.checkedItems.push(item);
                } else {
                    this.checkedItems.remove(item);
                }
            }
        });
    }
}


class EmailDigestSettings {
    constructor(data = {}) {
        this.email = ko.observable();

        this.isEnabled = ko.observable();

        this.remap(data);
    }

    remap(data) {
        this.isEnabled(data && data.email);

        if (!data) data = {};

        this.email(data.email);
    }


    enable() {
        $api.integrations.enableAlertsDigestEmail(
            { projectCode: auth.project.UniqueCode },
            {},
            (resp) => {
                this.isEnabled(true);
            }
        );
    }

    disable() {
        $api.integrations.disableAlertsDigestEmail(
            { projectCode: auth.project.UniqueCode },
            {},
            (resp) => {
                this.isEnabled(false);
            }
        );
    }
}

export default koComponent('alerts-view', AlertsView);
